import { parsePhoneNumberFromString } from 'libphonenumber-js';
import moment from 'moment';

export const mmss = (s) => {
    const n = Math.max(0, Number(s) || 0);
    const m = Math.floor(n / 60);
    const sec = Math.floor(n % 60);
    return `${m}:${String(sec).padStart(2, '0')}`;
};

export const formatPhone = (value) => {
    if (!value) return '—';
    let tel = String(value).trim().replace(/[^0-9]*/g, '');
    if (tel.length >= 13) tel = tel.slice(tel.length - 12);
    const phone = parsePhoneNumberFromString(`+${tel}`);
    return phone ? phone.formatInternational() : String(value);
};

export const callDir = (record) => {
    if (!record) return 'in';
    const raw = record.callType != null ? record.callType : record.CallType;
    if (raw === 1 || raw === '1') return 'out';
    const text = String(record.direction || record.type || raw || '').toLowerCase();
    if (text.includes('out') || text.includes('исход')) return 'out';
    return 'in';
};

export const recordPhone = (record) => (
    record && (record.address || record.Address || record.OrgNumber || record.originator)
);

export const recordQueue = (record) => {
    if (!record) return '';
    const q = record.queue;
    if (!q) return '';
    if (typeof q === 'string') return q;
    return q.name || q.DisplayName || '';
};

export const recordQueueId = (record) => {
    if (!record) return '';
    const q = record.queue;
    if (q && typeof q === 'object') return q.id || q._id || record.QueueID || '';
    return record.QueueID || q || '';
};

export const recordAgentLogin = (record) => {
    if (!record) return '';
    const op = record.operator;
    if (op && typeof op === 'object') return op.login || op.cc_agent || op.name || '';
    if (typeof op === 'string') return op;
    return record.agent || '';
};

export const recordAgent = (record) => {
    if (!record) return '';
    const op = record.operator;
    if (op && typeof op === 'object') return operatorLabel(op) || op.login || '';
    if (typeof op === 'string') return op;
    return record.agent || record.DestName || record.destination || '';
};

export const recordWhen = (record) => (
    record && (record.callTime || record.start || record.StartTime)
);

export const recordId = (row) => (row && (row.id || row._id || row.uid)) || null;

export const PLAYED_KEY = 'pc-visor-played';
export const NOTES_KEY = 'pc-visor-notes';
export const FLAG_KEY = 'pc-visor-flags';

export const readSet = (key) => {
    try {
        const raw = localStorage.getItem(key);
        const list = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(list) ? list : []);
    } catch (e) {
        return new Set();
    }
};

export const writeSet = (key, set) => {
    try {
        localStorage.setItem(key, JSON.stringify([...set]));
    } catch (e) { /* ignore */ }
};

export const readNotes = () => {
    try {
        const raw = localStorage.getItem(NOTES_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch (e) {
        return {};
    }
};

export const writeNotes = (notes) => {
    try {
        localStorage.setItem(NOTES_KEY, JSON.stringify(notes));
    } catch (e) { /* ignore */ }
};

export const formatWhen = (value) => {
    if (!value) return '—';
    const m = moment(value);
    return m.isValid() ? m.format('DD.MM.YYYY HH:mm:ss') : String(value);
};

export const formatTime = (value) => {
    if (!value) return '—';
    const m = moment(value);
    return m.isValid() ? m.format('HH:mm:ss') : String(value);
};

export const durationOf = (row) => {
    if (!row) return 0;
    return isoToSeconds(row.duration != null ? row.duration : row.Duration);
};

export const isoToSeconds = (input) => {
    if (typeof input === 'number' && Number.isFinite(input)) return Math.max(0, Math.floor(input));
    if (!input) return 0;
    const str = String(input).trim();
    if (/^\d+$/.test(str)) return Math.max(0, parseInt(str, 10));
    const hms = /^(\d+):([0-5]?\d):([0-5]?\d)$/.exec(str);
    if (hms) {
        return Number(hms[1]) * 3600 + Number(hms[2]) * 60 + Number(hms[3]);
    }
    const reptms = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;
    if (reptms.test(str)) {
        const matches = reptms.exec(str);
        const hours = matches[1] ? Number(matches[1]) : 0;
        const minutes = matches[2] ? Number(matches[2]) : 0;
        const seconds = matches[3] ? Number(matches[3]) : 0;
        return hours * 3600 + minutes * 60 + seconds;
    }
    const n = Number(str);
    return Number.isNaN(n) ? 0 : n;
};

export const formatTrackStart = (input) => {
    if (!input) return null;
    if (typeof input === 'string' && input.indexOf('/Date(') === 0) {
        const date = input.substring(6, 19);
        return moment(date, 'x').format('YYYY-MM-DD HH:mm:ss');
    }
    return input;
};

export const operatorLabel = (op) => {
    if (!op) return '';
    return op.fullname || [op.lastName, op.firstName].filter(Boolean).join(' ') || op.name || op.login || '';
};
